import AbstractBinaryOperatorFormulaNode from "./AbstractBinaryOperatorFormulaNode.js";

/**
 * `additionFormulaNode` is a concrete implementation of
 * `AbstractBinaryOperatorFormulaNode` representing an addition node.
 */
export default class AdditionFormulaNode extends AbstractBinaryOperatorFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitAdditionNode(this, additionalInformation);
	}

	getLabel() {
		return "+";
	}

	isAdditionFormulaNode() {
		return true;
	}

	static getType() {
		return "AdditionNode";
	}

	static precedence() {
		return this.additiveNodesPrecedence();
	}

	static build(builder, additionalInformation) {
		return builder.buildBinaryOperationNode(this, additionalInformation);
	}
}
